<a *ngIf="selectedTerm" href="#" class="dropdown-toggle" data-toggle="dropdown">
  <span>{{ selectedTerm.name }}</span>
</a>
<ul class="term-picker dropdown-menu">
  <li *ngFor="let term of terms" [ngClass]="{'hidden': term._id === selectedTerm?._id}">
    <a href="javascript:void(0)" (click)="changeSelectedTerm(term)">{{ term.name }}</a>
  </li>
</ul>
